module.exports = __webpack_public_path__ + "img/0-1.6a2a8863.svg";